<!-- eslint-disable vue/valid-v-slot -->
<!-- Tak jak w pozostałych stronach panelu: reguła nie rozumie slotów
     v-data-table z kropką w nazwie (item.status), a Vuetify 2 innej
     składni nie ma. Patrz LegalizationPage.vue, linia 1. -->
<template>
  <div class="marketing-page">
    <div class="page-header">
      <div class="page-header-text">
        <div class="page-eyebrow">Marketing</div>
        <h1 class="page-title">Posty i grafiki</h1>
      </div>
    </div>

    <v-tabs v-model="zakladka" background-color="transparent" show-arrows class="mb-4">
      <v-tab>Nowy post</v-tab>
      <v-tab>Moje projekty</v-tab>
      <v-tab>Szablony</v-tab>
      <v-tab>Biblioteka mediów</v-tab>
      <v-tab>Brand kit</v-tab>
    </v-tabs>

    <v-tabs-items v-model="zakladka" class="transparent">
      <!-- ══════════════════ NOWY POST ══════════════════ -->
      <v-tab-item>
        <v-row>
          <!-- lewa kolumna: formularz -->
          <v-col cols="12" md="5">
            <v-card class="pa-4 mb-4" outlined>
              <div class="sekcja-tytul">1. O czym jest post</div>
              <v-textarea
                v-model="temat"
                label="Temat"
                placeholder="np. Rekrutacja kierowców Bydgoszcz"
                rows="2" auto-grow outlined dense hide-details class="mb-3"
              />
              <v-select
                v-model="trybTworzenia"
                :items="tryby"
                item-text="etykieta" item-value="wartosc"
                label="Skąd bierzemy treść"
                outlined dense hide-details class="mb-3"
              />
              <v-textarea
                v-if="trybTworzenia === 'GOTOWY_TEKST'"
                v-model="gotowyTekst"
                label="Wklej gotowy tekst posta"
                rows="4" outlined dense hide-details class="mb-3"
              />
              <v-btn
                color="primary" block :loading="generujeTresc"
                :disabled="!temat || !szablonKlucz || !katalog.generatorTekstuDostepny"
                @click="generujTresc"
              >
                <v-icon left>mdi-auto-fix</v-icon>
                Wygeneruj treść
              </v-btn>
              <div v-if="!katalog.generatorTekstuDostepny" class="wskazowka mt-2">
                Generowanie treści jest wyłączone (brak klucza do modelu).
                Teksty można wpisać ręcznie poniżej.
              </div>
            </v-card>

            <v-card class="pa-4 mb-4" outlined>
              <div class="sekcja-tytul">2. Szablon i format</div>
              <v-select
                v-model="szablonKlucz" :items="katalog.szablony"
                item-text="nazwa" item-value="klucz"
                label="Szablon" outlined dense hide-details class="mb-2"
                @change="poZmianieSzablonu"
              >
                <template v-slot:item="{ item }">
                  <div class="poz-zdjecia">
                    <div class="poz-mini poz-mini-szablon">
                      <img v-if="podgladySzablonow[item.klucz]" :src="podgladySzablonow[item.klucz]" :alt="item.nazwa" />
                    </div>
                    <div class="poz-opis">
                      <div class="poz-nazwa">{{ item.nazwa }}</div>
                      <div class="poz-meta">{{ item.opis }}</div>
                    </div>
                  </div>
                </template>
              </v-select>
              <div v-if="wybranySzablon" class="wskazowka mb-3">{{ wybranySzablon.opis }}</div>
              <v-select
                v-model="format" :items="dostepneFormaty"
                item-text="nazwa" item-value="klucz"
                label="Format" outlined dense hide-details
              />
            </v-card>

            <v-card class="pa-4 mb-4" outlined>
              <div class="sekcja-tytul">3. Treść grafiki</div>
              <v-text-field
                v-if="maPole('plakietka')" v-model="tresc.plakietka"
                label="Plakietka" outlined dense hide-details class="mb-3" counter="18"
              />
              <v-text-field
                v-if="maPole('nadtytul')" v-model="tresc.nadtytul"
                label="Nadtytuł" outlined dense hide-details class="mb-3" counter="34"
              />
              <v-textarea
                v-if="maPole('naglowek')" v-model="tresc.naglowek"
                label="Nagłówek" hint="Najlepiej dwa krótkie zdania — złamie się po kropce"
                persistent-hint rows="2" auto-grow outlined dense class="mb-3" counter="42"
              />
              <v-textarea
                v-if="maPole('podtytul')" v-model="tresc.podtytul"
                label="Zdanie prowadzące" rows="2" auto-grow outlined dense hide-details
                class="mb-3" counter="80"
              />
              <v-text-field
                v-if="maPole('liczba')" v-model="tresc.liczba"
                label="Liczba lub data" outlined dense hide-details class="mb-3"
              />
              <v-text-field
                v-if="maPole('jednostka')" v-model="tresc.jednostka"
                label="Podpis pod liczbą" outlined dense hide-details class="mb-3"
              />
              <template v-if="maPole('korzysci')">
                <div class="etykieta-grupy">Korzyści (maksymalnie trzy)</div>
                <v-text-field
                  v-for="i in 3" :key="'k' + i"
                  v-model="korzysci[i - 1]" :label="'Korzyść ' + i"
                  outlined dense hide-details class="mb-2"
                />
              </template>
              <template v-if="maPole('kroki')">
                <div class="etykieta-grupy">Trzy kroki — kolejność ma znaczenie</div>
                <div v-for="i in 3" :key="'krok' + i" class="krok-pola">
                  <div class="krok-numer">0{{ i }}</div>
                  <div>
                    <v-text-field
                      v-model="krokiPola[i - 1].tytul" :label="'Krok ' + i + ' — tytuł'"
                      outlined dense hide-details class="mb-2" counter="40"
                    />
                    <v-text-field
                      v-model="krokiPola[i - 1].opis" :label="'Krok ' + i + ' — wyjaśnienie'"
                      outlined dense hide-details counter="90"
                    />
                  </div>
                </div>
              </template>

              <v-text-field
                v-if="maPole('stopka')" v-model="tresc.stopka"
                label="Stopka" outlined dense hide-details class="mb-3 mt-3" counter="48"
              />
              <v-combobox
                v-if="maPole('cta')" v-model="tresc.cta"
                :items="podpowiedziCta" label="Przycisk" outlined dense hide-details
                class="mb-3" counter="24"
              />
              <template v-if="maPole('zdjecie')">
                <v-autocomplete
                  v-model="wybraneZdjecie" :items="assetyDoWyboru"
                  item-text="szukajka" item-value="id"
                  label="Zdjęcie z biblioteki" placeholder="Wpisz, czego szukasz — auto, lampa, biuro…"
                  outlined dense clearable :hint="podpowiedzZdjecia" persistent-hint
                  no-data-text="Nic takiego nie ma w bibliotece."
                >
                  <template v-slot:item="{ item }">
                    <div class="poz-zdjecia">
                      <div class="poz-mini">
                        <img v-if="miniatury[item.id]" :src="miniatury[item.id]" :alt="item.nazwa" />
                      </div>
                      <div class="poz-opis">
                        <div class="poz-nazwa">{{ item.nazwa }}</div>
                        <div class="poz-meta">
                          {{ item.kategoria }}
                          <span v-if="item.uwaga" class="poz-uwaga">· {{ item.uwaga }}</span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:selection="{ item }">
                    <div class="poz-wybrana">
                      <div class="poz-mini poz-mini-mala">
                        <img v-if="miniatury[item.id]" :src="miniatury[item.id]" :alt="item.nazwa" />
                      </div>
                      <span class="poz-nazwa">{{ item.nazwa }}</span>
                    </div>
                  </template>
                </v-autocomplete>

                <div v-if="wybraneZdjecie && miniatury[wybraneZdjecie]" class="podglad-zdjecia mt-2">
                  <img :src="miniatury[wybraneZdjecie]" alt="Wybrane zdjęcie" />
                </div>
              </template>
            </v-card>

            <v-card v-if="teksty.pelnyTekst" class="pa-4 mb-4" outlined>
              <div class="sekcja-tytul">4. Treść posta do wklejenia</div>
              <v-textarea v-model="teksty.pelnyTekst" rows="6" auto-grow outlined dense hide-details class="mb-2" />
              <v-btn small text @click="kopiuj(teksty.pelnyTekst)">
                <v-icon left small>mdi-content-copy</v-icon> Kopiuj
              </v-btn>
              <v-expansion-panels flat class="mt-2">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0">Wariant krótszy i dłuższy</v-expansion-panel-header>
                  <v-expansion-panel-content class="px-0">
                    <v-textarea v-model="teksty.wariantKrotki" label="Krótszy" rows="2" auto-grow outlined dense hide-details class="mb-2" />
                    <v-textarea v-model="teksty.wariantDlugi" label="Dłuższy" rows="4" auto-grow outlined dense hide-details />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-col>

          <!-- prawa kolumna: podgląd -->
          <v-col cols="12" md="7">
            <v-card class="pa-4 podglad-karta" outlined>
              <div class="d-flex align-center mb-3">
                <div class="sekcja-tytul mb-0">Podgląd</div>
                <v-spacer />
                <v-progress-circular v-if="ladujePodglad" indeterminate size="18" width="2" color="primary" />
              </div>

              <div class="podglad-ramka">
                <div
                  v-if="svg" ref="plotno" class="podglad-svg"
                  @mousemove="ciagnij" @mouseup="puscElement" @mouseleave="puscElement"
                >
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <div v-html="svg"></div>

                  <!-- uchwyty do łapania elementów; rysowane po ramkach z backendu,
                       więc zawsze siedzą dokładnie tam, gdzie narysowany element -->
                  <div
                    v-for="el in elementy" :key="el.id"
                    class="uchwyt"
                    :class="{ 'uchwyt-wybrany': wybranyId === el.id, 'uchwyt-dodany': el.dodany }"
                    :style="ramkaUchwytu(el)"
                    :title="el.etykieta"
                    @mousedown.prevent="zlapElement(el, $event)"
                  >
                    <span class="uchwyt-nazwa">{{ el.etykieta }}</span>
                  </div>
                </div>
                <div v-else class="podglad-pusty">
                  Wpisz nagłówek albo wygeneruj treść — podgląd pojawi się od razu.
                </div>
              </div>

              <!-- ——— edytor wybranego elementu ——— -->
              <div v-if="wybrany" class="edytor mt-3">
                <div class="d-flex align-center mb-2">
                  <div class="sekcja-tytul mb-0">{{ wybrany.etykieta }}</div>
                  <v-spacer />
                  <v-btn x-small text @click="wybranyId = null">Odznacz</v-btn>
                </div>

                <div class="wskazowka mb-3">
                  Złap element na podglądzie i przeciągnij, albo przesuń strzałkami niżej.
                </div>

                <div class="d-flex align-center mb-3" style="gap: 6px">
                  <v-btn x-small outlined @click="przesun(-0.01, 0)"><v-icon x-small>mdi-arrow-left</v-icon></v-btn>
                  <v-btn x-small outlined @click="przesun(0.01, 0)"><v-icon x-small>mdi-arrow-right</v-icon></v-btn>
                  <v-btn x-small outlined @click="przesun(0, -0.01)"><v-icon x-small>mdi-arrow-up</v-icon></v-btn>
                  <v-btn x-small outlined @click="przesun(0, 0.01)"><v-icon x-small>mdi-arrow-down</v-icon></v-btn>
                  <v-spacer />
                  <v-btn x-small text @click="wyrownajDoMarginesu">Do marginesu</v-btn>
                </div>

                <template v-if="wybrany.typ === 'tekst' || wybrany.typ === 'cta' || wybrany.typ === 'plakietka'">
                  <div class="etykieta-grupy">Wielkość liter</div>
                  <v-slider
                    :value="rozmiarWybranego" min="0.008" max="0.20" step="0.002"
                    hide-details dense class="mt-0"
                    @input="ustawRozmiar"
                  />
                  <div class="etykieta-grupy">Wyrównanie</div>
                  <v-btn-toggle :value="wyrownanieWybranego" dense borderless class="mb-3" @change="ustawWyrownanie">
                    <v-btn x-small value="lewo"><v-icon x-small>mdi-format-align-left</v-icon></v-btn>
                    <v-btn x-small value="srodek"><v-icon x-small>mdi-format-align-center</v-icon></v-btn>
                    <v-btn x-small value="prawo"><v-icon x-small>mdi-format-align-right</v-icon></v-btn>
                  </v-btn-toggle>
                </template>

                <template v-if="wybrany.typ === 'zdjecie' && assetWybranego">
                  <div class="etykieta-grupy">Kadr — kliknij to, co ma zostać widoczne</div>
                  <div
                    ref="kadrownik" class="kadrownik"
                    @mousedown.prevent="zacznijKadr($event)"
                    @mousemove="ciagnijKadr($event)"
                    @mouseup="koniecKadru" @mouseleave="koniecKadru"
                  >
                    <img v-if="miniatury[assetWybranego]" :src="miniatury[assetWybranego]" alt="Kadrowanie" />
                    <div class="kadr-punkt" :style="pozycjaPunktuKadru"></div>
                  </div>
                  <div class="wskazowka mb-2">
                    Środek grafiki pokaże miejsce, które wskażesz. Przy zbliżeniu 1× widać
                    całą szerokość albo całą wysokość zdjęcia.
                  </div>

                  <div class="etykieta-grupy">Zbliżenie · {{ powiekszenieWybranego.toFixed(1) }}×</div>
                  <v-slider
                    :value="powiekszenieWybranego" min="1" max="3" step="0.1"
                    hide-details dense class="mt-0 mb-1"
                    @input="ustawPowiekszenie"
                  />
                  <div class="d-flex mb-3">
                    <v-btn x-small text @click="wysrodkujKadr">Wyśrodkuj kadr</v-btn>
                  </div>
                </template>

                <template v-if="wybrany.typ === 'logo' || wybrany.typ === 'zdjecie' || wybrany.typ === 'karta' || wybrany.typ === 'pasek'">
                  <div class="etykieta-grupy">Szerokość</div>
                  <v-slider
                    :value="szerokoscWybranego" min="0.05" max="1" step="0.01"
                    hide-details dense class="mt-0 mb-3"
                    @input="ustawSzerokosc"
                  />
                </template>

                <div class="etykieta-grupy">Kolor</div>
                <div class="d-flex flex-wrap mb-3">
                  <button
                    v-for="k in koloryDoWyboru" :key="k.nazwa"
                    class="kropka-koloru" :style="{ background: k.hex }"
                    :class="{ 'kropka-wybrana': kolorWybranego === k.nazwa }"
                    :title="k.nazwa" @click="ustawKolor(k.nazwa)"
                  />
                  <button class="kropka-koloru kropka-reset" title="Domyślny" @click="ustawKolor(null)">
                    <v-icon x-small>mdi-backup-restore</v-icon>
                  </button>
                </div>

                <template v-if="wybrany.dodany && wybrany.typ === 'tekst'">
                  <v-text-field
                    :value="tekstDodanego" label="Treść" outlined dense hide-details class="mb-3"
                    @input="ustawTekstDodanego"
                  />
                </template>
                <template v-if="wybrany.dodany && wybrany.typ === 'zdjecie'">
                  <v-select
                    :value="assetDodanego" :items="assetyDoWyboru"
                    item-text="nazwa" item-value="id" label="Zdjęcie"
                    outlined dense hide-details class="mb-3" @change="ustawAssetDodanego"
                  />
                </template>

                <div class="d-flex">
                  <v-btn x-small text @click="przywrocElement">Przywróć domyślne</v-btn>
                  <v-spacer />
                  <v-btn v-if="wybrany.dodany" x-small text color="error" @click="usunDodany">Usuń</v-btn>
                  <v-btn v-else x-small text color="warning" @click="ukryjElement">Schowaj</v-btn>
                </div>
              </div>

              <!-- ——— dodawanie elementów ——— -->
              <div class="d-flex flex-wrap mt-3" style="gap: 8px">
                <v-btn x-small outlined @click="dodajElement('tekst')">
                  <v-icon left x-small>mdi-format-text</v-icon> Dodaj tekst
                </v-btn>
                <v-btn x-small outlined @click="dodajElement('karta')">
                  <v-icon left x-small>mdi-rectangle-outline</v-icon> Dodaj kafelek
                </v-btn>
                <v-btn x-small outlined :disabled="!assety.length" @click="dodajElement('zdjecie')">
                  <v-icon left x-small>mdi-image-plus</v-icon> Dodaj zdjęcie
                </v-btn>
                <v-spacer />
                <v-btn v-if="maZmianyUkladu" x-small text color="warning" @click="wyczyscUklad">
                  Cofnij wszystkie przesunięcia
                </v-btn>
              </div>

              <div v-if="ukryte.length" class="mt-2">
                <div class="etykieta-grupy">Schowane elementy</div>
                <v-chip
                  v-for="id in ukryte" :key="id" x-small class="mr-1 mb-1" close
                  @click:close="pokazElement(id)"
                >{{ id }}</v-chip>
              </div>

              <div v-if="ostrzezenia.length" class="mt-3">
                <v-alert
                  v-for="(o, i) in ostrzezenia" :key="i" dense text class="mb-2"
                  :type="o.waga === 'powazne' ? 'error' : (o.waga === 'uwaga' ? 'warning' : 'info')"
                >
                  {{ o.tresc }}
                </v-alert>
              </div>

              <div class="d-flex flex-wrap mt-4" style="gap: 8px">
                <v-btn color="primary" :loading="zapisuje" :disabled="!mozeZapisac" @click="zapisz">
                  <v-icon left>mdi-content-save</v-icon>
                  {{ projektId ? 'Zapisz zmiany' : 'Zapisz projekt' }}
                </v-btn>
                <v-btn outlined :disabled="!projektId" :loading="eksportuje" @click="eksportuj([format])">
                  <v-icon left>mdi-download</v-icon> Pobierz {{ nazwaFormatu }}
                </v-btn>
                <v-btn outlined :disabled="!projektId" :loading="eksportuje" @click="eksportuj(wszystkieFormatySzablonu)">
                  <v-icon left>mdi-image-multiple</v-icon> Wszystkie formaty
                </v-btn>
                <v-btn v-if="projektId" text @click="nowyProjekt">Nowy post</v-btn>
              </div>

              <div v-if="projektId" class="d-flex align-center mt-3" style="gap: 10px">
                <span class="etykieta-grupy mb-0">Rozdzielczość</span>
                <v-btn-toggle v-model="skalaEksportu" mandatory dense borderless>
                  <v-btn :value="1" x-small>1× · sieć</v-btn>
                  <v-btn :value="2" x-small>2× · druk</v-btn>
                </v-btn-toggle>
                <span class="wskazowka">{{ opisSkali }}</span>
              </div>

              <div v-if="projektId && wersje.length" class="mt-4">
                <v-expansion-panels flat>
                  <v-expansion-panel class="panel-historii">
                    <v-expansion-panel-header class="px-0">
                      <span class="etykieta-grupy mb-0">Historia zmian ({{ wersje.length }})</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="px-0">
                      <div class="wskazowka mb-2">
                        Każdy zapis odkłada poprzedni stan. Przywrócenie też trafia do historii,
                        więc da się je cofnąć.
                      </div>
                      <div v-for="w in wersje" :key="w.id" class="wersja">
                        <div class="wersja-numer">{{ w.numer }}</div>
                        <div class="wersja-opis">
                          <div>{{ w.opis || 'Zapis bez opisu' }}</div>
                          <div class="wskazowka">
                            {{ data(w.createdAt) }}<span v-if="w.utworzyl"> · {{ w.utworzyl }}</span>
                          </div>
                        </div>
                        <v-btn x-small text color="primary" :loading="przywracam === w.numer"
                               @click="przywrocWersje(w)">Przywróć</v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>

              <div v-if="rendery.length" class="mt-4">
                <div class="etykieta-grupy">Wyeksportowane pliki</div>
                <v-chip
                  v-for="r in rendery" :key="r.id" small class="mr-2 mb-2"
                  @click="pobierzPlik(r)"
                >
                  <v-icon left small>mdi-file-image</v-icon>
                  {{ nazwaFormatuZKlucza(r.format) }} · {{ r.szerokosc }}×{{ r.wysokosc }}
                </v-chip>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- ══════════════════ MOJE PROJEKTY ══════════════════ -->
      <v-tab-item>
        <v-card outlined>
          <v-data-table
            :headers="naglowkiProjektow" :items="projekty" :loading="ladujeProjekty"
            no-data-text="Nie ma jeszcze żadnego projektu." class="transparent"
          >
            <template v-slot:item.status="{ item }">
              <v-chip x-small :color="kolorStatusu(item.status)" dark>{{ etykietaStatusu(item.status) }}</v-chip>
            </template>
            <template v-slot:item.updatedAt="{ item }">{{ data(item.updatedAt) }}</template>
            <template v-slot:item.akcje="{ item }">
              <v-btn small text @click="otworz(item)">Otwórz</v-btn>
              <v-btn small text :loading="duplikuje === item.id" @click="duplikuj(item)">Zrób podobny</v-btn>
              <v-btn
                v-if="item.status !== 'ZATWIERDZONA'" small text color="success"
                @click="zatwierdz(item)"
              >Zatwierdź</v-btn>
              <v-btn small text color="error" @click="usun(item)">Usuń</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <!-- ══════════════════ SZABLONY ══════════════════ -->
      <v-tab-item>
        <v-row>
          <v-col v-for="s in katalog.szablony" :key="s.klucz" cols="12" sm="6" md="4">
            <v-card outlined class="pa-4 h-100">
              <div class="szablon-podglad mb-3">
                <img v-if="podgladySzablonow[s.klucz]" :src="podgladySzablonow[s.klucz]" :alt="s.nazwa" />
                <v-progress-circular v-else indeterminate size="20" width="2" color="primary" />
              </div>
              <div class="d-flex align-center mb-1">
                <div class="sekcja-tytul mb-0">{{ s.nazwa }}</div>
                <v-spacer />
                <v-chip x-small outlined>{{ s.rodzina }}</v-chip>
              </div>
              <div class="wskazowka mb-3">{{ s.opis }}</div>
              <div class="etykieta-grupy">Formaty</div>
              <v-chip v-for="f in s.formaty" :key="f" x-small class="mr-1 mb-1">
                {{ nazwaFormatuZKlucza(f) }}
              </v-chip>
              <v-btn small color="primary" class="mt-3" block @click="uzyjSzablonu(s)">
                Użyj tego szablonu
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- ══════════════════ BIBLIOTEKA MEDIÓW ══════════════════ -->
      <v-tab-item>
        <v-card outlined class="pa-4 mb-4">
          <div class="d-flex align-center flex-wrap" style="gap: 12px">
            <v-select
              v-model="filtrKategorii" :items="kategorieZWszystkimi" label="Kategoria"
              outlined dense hide-details style="max-width: 240px" @change="wczytajAssety"
            />
            <v-spacer />
            <input ref="wejsciePliku" type="file" accept="image/*" class="d-none" @change="wgrajAsset" />
            <v-btn color="primary" :loading="wgrywa" @click="$refs.wejsciePliku.click()">
              <v-icon left>mdi-upload</v-icon> Dodaj zdjęcie
            </v-btn>
            <v-btn
              v-if="katalog.generatorObrazowDostepny" outlined color="primary"
              @click="dialogObrazu = true"
            >
              <v-icon left>mdi-auto-fix</v-icon> Wygeneruj grafikę
            </v-btn>
          </div>
        </v-card>

        <v-row>
          <v-col v-for="a in assety" :key="a.id" cols="6" sm="4" md="3">
            <v-card outlined class="pa-3">
              <div class="asset-podglad mb-2">
                <img v-if="miniatury[a.id]" :src="miniatury[a.id]" :alt="a.nazwa" />
                <div v-else class="asset-podglad-pusty"><v-icon small>mdi-image</v-icon></div>
              </div>
              <div class="asset-nazwa">{{ a.nazwa }}</div>
              <div class="wskazowka mb-2">
                {{ a.kategoria }}<span v-if="a.szerokosc"> · {{ a.szerokosc }}×{{ a.wysokosc }}</span>
              </div>
              <v-chip v-if="a.widocznaPlatforma" x-small color="warning" dark class="mr-1 mb-1">
                widoczny Bolt/Uber
              </v-chip>
              <v-chip v-if="a.widocznaTablica" x-small color="warning" dark class="mr-1 mb-1">
                widoczna tablica
              </v-chip>
              <v-chip v-if="a.aiWygenerowane" x-small color="info" dark class="mr-1 mb-1">AI</v-chip>
              <div class="d-flex mt-2">
                <v-btn x-small text @click="edytujAsset(a)">Opisz</v-btn>
                <v-spacer />
                <v-btn x-small text color="error" @click="usunAsset(a)">Usuń</v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <div v-if="!assety.length" class="wskazowka">
          Biblioteka jest pusta. Dodaj zdjęcia floty, biura albo zrzuty z aplikacji —
          generator będzie je podpowiadał przy tworzeniu postów.
        </div>
      </v-tab-item>

      <!-- ══════════════════ BRAND KIT ══════════════════ -->
      <v-tab-item>
        <v-card outlined class="pa-4 mb-4">
          <div class="sekcja-tytul">Kolory z księgi znaku</div>
          <div class="wskazowka mb-3">
            Te cztery kolory są identyfikacją BTP. Pochodzą wprost z księgi znaku.
          </div>
          <div class="d-flex flex-wrap">
            <div v-for="(hex, nazwa) in katalog.brandKit.koloryKsiegi" :key="nazwa" class="probka">
              <div class="probka-kolor" :style="{ background: hex }"></div>
              <div class="probka-nazwa">{{ nazwa }}</div>
              <div class="probka-hex">{{ hex }}</div>
            </div>
          </div>
        </v-card>

        <v-card outlined class="pa-4 mb-4">
          <div class="sekcja-tytul">Kolory ekranowe</div>
          <div class="wskazowka mb-3">
            Odcienie używane na grafikach w mediach społecznościowych — zmierzone
            z dotychczasowych materiałów BTP, nie dobrane na oko.
          </div>
          <div class="d-flex flex-wrap">
            <div v-for="(hex, nazwa) in koloryEkranowe" :key="nazwa" class="probka">
              <div class="probka-kolor" :style="{ background: hex }"></div>
              <div class="probka-nazwa">{{ nazwa }}</div>
              <div class="probka-hex">{{ hex }}</div>
            </div>
          </div>
        </v-card>

        <v-card outlined class="pa-4">
          <div class="sekcja-tytul">Zasady znaku</div>
          <ul class="zasady">
            <li>
              Pole ochronne wokół logo równe wysokości litery „P" z logotypu —
              generator pilnuje go automatycznie.
            </li>
            <li>
              Minimalny rozmiar znaku: {{ katalog.brandKit.zasadyZnaku.minimalnaSzerokoscPx }} px
              na ekranie, {{ katalog.brandKit.zasadyZnaku.minimalnaSzerokoscMm }} mm w druku.
            </li>
            <li>
              Wysokość logo zawsze liczona z szerokości (proporcja
              {{ katalog.brandKit.zasadyZnaku.proporcjaZnaku }}) — znaku nie da się rozciągnąć.
            </li>
            <li>Nie wolno usuwać miasta ani napisu BTP, obracać znaku ani zmieniać jego kolorów.</li>
            <li>Strona: {{ katalog.brandKit.marka.strona }}</li>
          </ul>
        </v-card>
      </v-tab-item>
    </v-tabs-items>

    <!-- opis materiału -->
    <!-- ═══════════ GENEROWANIE GRAFIKI PRZEZ AI ═══════════ -->
    <v-dialog v-model="dialogObrazu" max-width="620" persistent>
      <v-card class="pa-4">
        <div class="sekcja-tytul">Wygeneruj grafikę</div>
        <div class="wskazowka mb-3">
          Model dostaje nasz brief i grafikę wzorcową BTP, więc trzyma się palety
          i światła z księgi znaku. Napisów nie rysuje — tekst składa generator
          z prawdziwych krojów.
        </div>

        <v-textarea
          v-model="obraz.opis" label="Co ma być na grafice" outlined dense rows="3"
          counter="600" maxlength="600" class="mb-3"
          placeholder="np. mokra ulica w centrum wieczorem, światła aut rozmyte w tle"
        />
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-select
              v-model="obraz.rodzaj" :items="rodzajeObrazu" label="Rodzaj"
              outlined dense hide-details class="mb-3"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="obraz.format" :items="formatyObrazu" label="Format"
              outlined dense hide-details class="mb-3"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="obraz.miejsceNaTekst" :items="miejscaNaTekst" label="Gdzie zostawić miejsce na tekst"
              outlined dense hide-details class="mb-3"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              v-model="obraz.jakosc" :items="jakosciObrazu" label="Jakość"
              outlined dense hide-details class="mb-3"
            />
          </v-col>
        </v-row>
        <v-checkbox
          v-model="obraz.wariantJasny" hide-details class="mt-0 mb-2"
          label="Wersja na jasnym tle (do druku na białym papierze)"
        />

        <v-alert dense text type="info" class="mb-3">
          Koszt tej grafiki: około <strong>{{ kosztSzacowany }}</strong>.
          Gotowa trafi do biblioteki z oznaczeniem „AI”.
        </v-alert>

        <div class="d-flex">
          <v-spacer />
          <v-btn text :disabled="generujeObraz" @click="dialogObrazu = false">Anuluj</v-btn>
          <v-btn
            color="primary" :loading="generujeObraz"
            :disabled="!obraz.opis || obraz.opis.trim().length < 3"
            @click="wygenerujObraz"
          >
            Generuj
          </v-btn>
        </div>
        <div v-if="generujeObraz" class="wskazowka mt-3">
          Generowanie trwa od kilkunastu sekund do dwóch minut. Nie zamykaj okna.
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAssetu" max-width="520">
      <v-card v-if="edytowanyAsset" class="pa-4">
        <div class="sekcja-tytul">Opis materiału</div>
        <v-text-field v-model="edytowanyAsset.nazwa" label="Nazwa" outlined dense hide-details class="mb-3" />
        <v-select
          v-model="edytowanyAsset.kategoria" :items="kategorie" label="Kategoria"
          outlined dense hide-details class="mb-3"
        />
        <v-select
          v-model="edytowanyAsset.prawa" :items="prawa" label="Prawa do użycia"
          outlined dense hide-details class="mb-3"
        />
        <v-checkbox
          v-model="edytowanyAsset.widocznaPlatforma" hide-details class="mt-0"
          label="Widoczne oklejenie Bolt / Uber / FreeNow"
        />
        <v-checkbox
          v-model="edytowanyAsset.widocznaTablica" hide-details class="mt-0"
          label="Widoczna tablica rejestracyjna"
        />
        <v-checkbox
          v-model="edytowanyAsset.aiWygenerowane" hide-details class="mt-0 mb-3"
          label="Zdjęcie powstało lub było poprawiane modelem AI"
        />
        <div class="wskazowka mb-3">
          Oznaczone materiały nie są podpowiadane przy zwykłym poście — brief marki
          zabrania pokazywania logotypów platform, a instrukcja szablonów wymaga
          maskowania tablic.
        </div>
        <div class="d-flex">
          <v-spacer />
          <v-btn text @click="dialogAssetu = false">Anuluj</v-btn>
          <v-btn color="primary" :loading="zapisujeAsset" @click="zapiszAsset">Zapisz</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
const axios = require("axios");

/** Opóźnienie podglądu: tyle czekamy po ostatnim naciśnięciu klawisza. */
const OPOZNIENIE_PODGLADU = 350;

export default {
  name: "MarketingPostsPage",

  data() {
    return {
      zakladka: 0,

      katalog: { szablony: [], formaty: [], brandKit: { koloryKsiegi: {}, kolory: {}, marka: {}, zasadyZnaku: {} }, generatorTekstuDostepny: false, generatorObrazowDostepny: false },

      // formularz
      temat: "",
      trybTworzenia: "TEMAT",
      gotowyTekst: "",
      szablonKlucz: null,
      format: null,
      tresc: {},
      korzysci: ["", "", ""],
      krokiPola: [
        { tytul: "", opis: "" },
        { tytul: "", opis: "" },
        { tytul: "", opis: "" },
      ],
      wybraneZdjecie: null,
      teksty: {},

      skalaEksportu: 1,

      // projekt
      projektId: null,
      rendery: [],
      wersje: [],
      przywracam: null,

      // układ: RÓŻNICA wobec szablonu, nie kopia całego układu
      uklad: { nadpisania: {}, dodatkowe: [] },
      elementy: [],
      wybranyId: null,
      przeciaganie: null,
      kadrowanieWToku: false,

      // podgląd
      svg: "",
      ostrzezenia: [],
      ladujePodglad: false,
      licznikPodgladu: null,
      /** Numer ostatniego żądania — starsza odpowiedź nie może nadpisać nowszej. */
      numerZadania: 0,

      // stany
      generujeTresc: false,
      zapisuje: false,
      eksportuje: false,
      ladujeProjekty: false,
      wgrywa: false,
      zapisujeAsset: false,

      projekty: [],
      assety: [],
      miniatury: {},
      podgladySzablonow: {},
      duplikuje: null,
      filtrKategorii: "WSZYSTKIE",
      dialogAssetu: false,
      edytowanyAsset: null,

      // generowanie grafiki przez AI
      dialogObrazu: false,
      generujeObraz: false,
      obraz: {
        opis: "",
        rodzaj: "tlo",
        format: "post-4-5",
        miejsceNaTekst: "brak",
        jakosc: "medium",
        wariantJasny: false,
      },
      rodzajeObrazu: [
        { value: "tlo", text: "Tło pod tekst" },
        { value: "scena", text: "Scena — konkretna sytuacja" },
        { value: "obiekt", text: "Pojedynczy przedmiot" },
        { value: "faktura", text: "Faktura / deseń" },
        { value: "abstrakcja", text: "Abstrakcja — formy i światło" },
      ],
      miejscaNaTekst: [
        { value: "brak", text: "Nie zostawiaj — całe wypełnione" },
        { value: "gora", text: "Na górze" },
        { value: "dol", text: "Na dole" },
        { value: "lewa", text: "Po lewej" },
        { value: "prawa", text: "Po prawej" },
        { value: "srodek", text: "Na środku" },
      ],
      // Groszowe kwoty biora sie z cennika gpt-image-2 przeliczonego po 3,86 zl/USD
      // i obejmuja doliczany obraz referencyjny — backend liczy tak samo.
      jakosciObrazu: [
        { value: "low", text: "Szybka — ok. 8 gr" },
        { value: "medium", text: "Standard — ok. 30 gr" },
        { value: "high", text: "Najlepsza — ok. 75 gr" },
      ],

      tryby: [
        { wartosc: "TEMAT", etykieta: "Napisz od tematu" },
        { wartosc: "GOTOWY_TEKST", etykieta: "Mam gotowy tekst" },
      ],
      kategorie: ["LOGO", "AUTA", "FLOTA", "KIEROWCY", "BIURO", "MIASTO", "WYDARZENIA", "PRACOWNICY", "IKONY", "TLA", "MOCKUPY", "EKRANY", "INNE"],
      prawa: ["WLASNE", "LICENCJA", "AI", "NIEZNANE"],
      podpowiedziCta: ["Dołącz do BTP", "Zacznij jeździć", "Sprawdź ofertę", "Dowiedz się więcej", "Zobacz szczegóły", "www.btpartner.pl"],

      naglowkiProjektow: [
        { text: "Tytuł", value: "tytul" },
        { text: "Szablon", value: "szablon" },
        { text: "Status", value: "status" },
        { text: "Zmieniony", value: "updatedAt" },
        { text: "", value: "akcje", sortable: false, align: "end" },
      ],
    };
  },

  computed: {
    wybranySzablon() {
      return this.katalog.szablony.find((s) => s.klucz === this.szablonKlucz) || null;
    },
    dostepneFormaty() {
      if (!this.wybranySzablon) return [];
      return this.katalog.formaty.filter((f) => this.wybranySzablon.formaty.includes(f.klucz));
    },
    wszystkieFormatySzablonu() {
      return this.wybranySzablon ? this.wybranySzablon.formaty : [];
    },
    nazwaFormatu() {
      return this.nazwaFormatuZKlucza(this.format);
    },
    opisSkali() {
      const f = this.katalog.formaty.find((x) => x.klucz === this.format);
      if (!f) return "";
      const s = this.skalaEksportu;
      return `${f.szerokosc * s} × ${f.wysokosc * s} px`;
    },
    mozeZapisac() {
      return !!(this.szablonKlucz && this.format && (this.tresc.naglowek || this.tresc.liczba));
    },
    koloryEkranowe() {
      const wszystkie = this.katalog.brandKit.kolory || {};
      const zKsiegi = Object.keys(this.katalog.brandKit.koloryKsiegi || {});
      const wynik = {};
      Object.keys(wszystkie).forEach((k) => {
        if (!zKsiegi.includes(k)) wynik[k] = wszystkie[k];
      });
      return wynik;
    },
    /** Formaty do generowania — bierzemy z katalogu, zeby nie dublowac listy. */
    formatyObrazu() {
      return (this.katalog.formaty || []).map((f) => ({ value: f.klucz, text: f.nazwa }));
    },

    kosztSzacowany() {
      const j = this.jakosciObrazu.find((x) => x.value === this.obraz.jakosc);
      return j ? j.text.split("— ")[1] : "30 gr";
    },

    assetyDoWyboru() {
      // Materiały z widocznym logo platformy albo tablicą idą na koniec listy —
      // nadal można ich użyć świadomie, ale nie podsuwamy ich jako pierwszych.
      //
      // `szukajka` sklej nazwę, kategorię i tagi, bo po tym polu filtruje
      // wyszukiwarka: wpisanie „lampa" ma znaleźć zdjęcie, które ma lampę
      // w tagach, nawet jeśli nie ma jej w nazwie.
      const opisz = (a) => ({
        ...a,
        uwaga: this.powodUwagi(a),
        szukajka: [a.nazwa, a.kategoria, ...(a.tagi || [])].join(" "),
      });
      const czyste = this.assety.filter((a) => !a.widocznaPlatforma && !a.widocznaTablica).map(opisz);
      const zUwaga = this.assety.filter((a) => a.widocznaPlatforma || a.widocznaTablica).map(opisz);
      return [...czyste, ...zUwaga];
    },
    podpowiedzZdjecia() {
      const a = this.assety.find((x) => x.id === this.wybraneZdjecie);
      if (!a) return "Realne zdjęcia BTP mają pierwszeństwo przed materiałem z zewnątrz.";
      if (a.widocznaPlatforma) return "Uwaga: widoczne logo platformy — brief marki zabrania tego bez wyraźnej potrzeby.";
      if (a.widocznaTablica) return "Uwaga: widoczna tablica rejestracyjna — instrukcja wymaga zamaskowania.";
      return "";
    },
    kategorieZWszystkimi() {
      return ["WSZYSTKIE", ...this.kategorie];
    },

    wybrany() {
      return this.elementy.find((e) => e.id === this.wybranyId) || null;
    },
    nadpisanieWybranego() {
      return (this.wybranyId && this.uklad.nadpisania[this.wybranyId]) || {};
    },
    rozmiarWybranego() {
      if (!this.wybrany) return 0.03;
      return this.nadpisanieWybranego.rozmiar != null
        ? this.nadpisanieWybranego.rozmiar
        : (this.wybrany.rozmiar || 0.03);
    },
    szerokoscWybranego() {
      if (!this.wybrany) return 0.3;
      return this.nadpisanieWybranego.szerokosc != null
        ? this.nadpisanieWybranego.szerokosc
        : (this.wybrany.szerokoscElementu || this.wybrany.szerokosc);
    },
    wyrownanieWybranego() {
      return this.nadpisanieWybranego.wyrownanie || null;
    },
    kolorWybranego() {
      return this.nadpisanieWybranego.kolor || null;
    },
    /** Identyfikator zdjęcia pod zaznaczonym elementem — z szablonu albo z dodanego. */
    assetWybranego() {
      if (!this.wybrany || this.wybrany.typ !== "zdjecie") return null;
      if (this.wybrany.dodany) return this.elementDodany ? this.elementDodany.asset : null;
      return this.wybraneZdjecie;
    },
    kadrWybranego() {
      const n = this.nadpisanieWybranego;
      return {
        x: n.kadrX != null ? n.kadrX : 0.5,
        y: n.kadrY != null ? n.kadrY : 0.5,
      };
    },
    powiekszenieWybranego() {
      const n = this.nadpisanieWybranego;
      return n.powiekszenie != null ? n.powiekszenie : 1;
    },
    pozycjaPunktuKadru() {
      return { left: this.kadrWybranego.x * 100 + "%", top: this.kadrWybranego.y * 100 + "%" };
    },
    elementDodany() {
      if (!this.wybranyId) return null;
      return this.uklad.dodatkowe.find((d) => d.id === this.wybranyId) || null;
    },
    tekstDodanego() {
      return this.elementDodany ? this.elementDodany.tekst : "";
    },
    assetDodanego() {
      return this.elementDodany ? this.elementDodany.asset : null;
    },
    koloryDoWyboru() {
      const k = this.katalog.brandKit.kolory || {};
      const chce = ["bialy", "akcent", "cta", "logoNaCiemnym", "elektryczny", "bursztyn", "tekstJasny", "granat", "niebieski", "tlo"];
      return chce.filter((n) => k[n]).map((n) => ({ nazwa: n, hex: k[n] }));
    },
    maZmianyUkladu() {
      return Object.keys(this.uklad.nadpisania).length > 0 || this.uklad.dodatkowe.length > 0;
    },
    ukryte() {
      return Object.keys(this.uklad.nadpisania).filter((id) => this.uklad.nadpisania[id].ukryta);
    },
  },

  watch: {
    tresc: { handler: "zaplanujPodglad", deep: true },
    korzysci: { handler: "zaplanujPodglad", deep: true },
    krokiPola: { handler: "zaplanujPodglad", deep: true },
    wybraneZdjecie: "zaplanujPodglad",
    format: "zaplanujPodglad",
    szablonKlucz: "zaplanujPodglad",
    uklad: { handler: "zaplanujPodglad", deep: true },
  },

  async mounted() {
    await this.wczytajKatalog();
    await Promise.all([this.wczytajProjekty(), this.wczytajAssety()]);
  },

  beforeDestroy() {
    if (this.licznikPodgladu) clearTimeout(this.licznikPodgladu);
    // adresy obiektowe żyją do końca sesji przeglądarki, jeśli ich nie zwolnić
    Object.values(this.miniatury).forEach((u) => window.URL.revokeObjectURL(u));
    Object.values(this.podgladySzablonow).forEach((u) => window.URL.revokeObjectURL(u));
  },

  methods: {
    api(sciezka) {
      return process.env.VUE_APP_ROOT_API + "marketing" + sciezka;
    },
    getConfig() {
      return { headers: { Authorization: "Bearer " + localStorage.getItem("token") } };
    },

    // ─────────────────────────── wczytywanie ───────────────────────────

    async wczytajKatalog() {
      try {
        const res = await axios.get(this.api("/katalog"), this.getConfig());
        this.katalog = res.data.data;
        if (!this.szablonKlucz && this.katalog.szablony.length) {
          this.uzyjSzablonu(this.katalog.szablony[0], false);
        }
        this.wczytajPodgladySzablonow();
      } catch (e) {
        this.blad(e, "Nie udało się wczytać katalogu szablonów.");
      }
    },

    /**
     * Miniatury szablonów. Renderuje je backend z przykładowej treści szablonu,
     * więc nie mogą się rozjechać z tym, co użytkownik naprawdę dostanie.
     */
    async wczytajPodgladySzablonow() {
      for (const s of this.katalog.szablony) {
        if (this.podgladySzablonow[s.klucz]) continue;
        try {
          const res = await axios.get(this.api("/szablony/" + s.klucz + "/podglad"), {
            ...this.getConfig(), responseType: "blob",
          });
          this.$set(this.podgladySzablonow, s.klucz, window.URL.createObjectURL(res.data));
        } catch (e) {
          // brak jednej miniatury nie może zablokować wyboru szablonu
        }
      }
    },

    async duplikuj(projekt) {
      this.duplikuje = projekt.id;
      try {
        const res = await axios.post(this.api("/projekty/" + projekt.id + "/duplikuj"), {}, this.getConfig());
        await this.wczytajProjekty();
        await this.otworz({ id: res.data.data.id });
        this.$swal.fire({
          icon: "success", title: "Zrobiłem kopię",
          text: "Otworzyłem ją do edycji. Oryginał został bez zmian.",
          timer: 2200, showConfirmButton: false,
        });
      } catch (e) {
        this.blad(e, "Nie udało się zrobić kopii.");
      } finally {
        this.duplikuje = null;
      }
    },

    async wczytajProjekty() {
      this.ladujeProjekty = true;
      try {
        const res = await axios.get(this.api("/projekty"), this.getConfig());
        this.projekty = res.data.data;
      } catch (e) {
        this.blad(e, "Nie udało się wczytać projektów.");
      } finally {
        this.ladujeProjekty = false;
      }
    },

    async wczytajAssety() {
      try {
        const kat = this.filtrKategorii && this.filtrKategorii !== "WSZYSTKIE"
          ? "?kategoria=" + this.filtrKategorii : "";
        const res = await axios.get(this.api("/assety" + kat), this.getConfig());
        this.assety = res.data.data;
        this.wczytajMiniatury();
      } catch (e) {
        this.blad(e, "Nie udało się wczytać biblioteki mediów.");
      }
    },

    // ─────────────────────────── szablon ───────────────────────────

    uzyjSzablonu(s, przejdz = true) {
      this.szablonKlucz = s.klucz;
      this.format = s.formaty[0];
      if (!this.tresc.naglowek) {
        this.tresc = { ...s.przyklad };
        this.korzysci = [...(s.przyklad.korzysci || []), "", "", ""].slice(0, 3);
        this.krokiPola = [...(s.przyklad.kroki || []), {}, {}, {}]
          .slice(0, 3)
          .map((k) => ({ tytul: k.tytul || "", opis: k.opis || "" }));
      }
      if (przejdz) this.zakladka = 0;
    },

    poZmianieSzablonu() {
      if (this.wybranySzablon && !this.wybranySzablon.formaty.includes(this.format)) {
        this.format = this.wybranySzablon.formaty[0];
      }
    },

    maPole(pole) {
      return this.wybranySzablon ? this.wybranySzablon.pola.includes(pole) : false;
    },

    // ─────────────────────────── treść przez AI ───────────────────────────

    async generujTresc() {
      this.generujeTresc = true;
      try {
        const res = await axios.post(this.api("/generuj-tresc"), {
          temat: this.temat,
          szablon: this.szablonKlucz,
          gotowyTekst: this.trybTworzenia === "GOTOWY_TEKST" ? this.gotowyTekst : undefined,
        }, this.getConfig());
        const d = res.data.data;
        this.tresc = {
          plakietka: d.plakietka, nadtytul: d.nadtytul, naglowek: d.naglowek,
          podtytul: d.podtytul, stopka: d.stopka, cta: d.cta,
          liczba: d.liczba, jednostka: d.jednostka,
        };
        this.korzysci = [...(d.korzysci || []), "", "", ""].slice(0, 3);
        this.krokiPola = [...(d.kroki || []), {}, {}, {}]
          .slice(0, 3)
          .map((k) => ({ tytul: k.tytul || "", opis: k.opis || "" }));
        this.teksty = {
          pelnyTekst: d.pelnyTekst, wariantKrotki: d.wariantKrotki, wariantDlugi: d.wariantDlugi,
        };
        if (d.przyciete && d.przyciete.length) {
          this.$swal.fire({
            icon: "info",
            title: "Skróciłem kilka pól",
            text: "Za długie było: " + d.przyciete.join(", ") + ". Możesz je poprawić przed zapisem.",
          });
        }
      } catch (e) {
        this.blad(e, "Nie udało się wygenerować treści.");
      } finally {
        this.generujeTresc = false;
      }
    },

    // ─────────────────────────── podgląd ───────────────────────────

    zbudujTresc() {
      return {
        ...this.tresc,
        korzysci: this.korzysci.filter((k) => k && k.trim()),
        kroki: this.krokiPola
          .filter((k) => k.tytul && k.tytul.trim())
          .map((k) => ({ tytul: k.tytul.trim(), opis: (k.opis || "").trim() || undefined })),
        zdjecia: this.wybraneZdjecie ? [this.wybraneZdjecie] : [],
      };
    },

    zaplanujPodglad() {
      if (this.licznikPodgladu) clearTimeout(this.licznikPodgladu);
      this.licznikPodgladu = setTimeout(this.odswiezPodglad, OPOZNIENIE_PODGLADU);
    },

    async odswiezPodglad() {
      if (!this.szablonKlucz || !this.format) return;
      if (!this.tresc.naglowek && !this.tresc.liczba) { this.svg = ""; this.ostrzezenia = []; return; }

      const mojNumer = ++this.numerZadania;
      this.ladujePodglad = true;
      try {
        const res = await axios.post(this.api("/podglad"), {
          szablon: this.szablonKlucz, format: this.format,
          tresc: this.zbudujTresc(), uklad: this.uklad,
        }, this.getConfig());
        // odpowiedź na starsze żądanie przyszła po nowszym — ignorujemy,
        // inaczej podgląd „cofa się" przy szybkim pisaniu
        if (mojNumer !== this.numerZadania) return;
        this.svg = res.data.data.svg;
        this.ostrzezenia = res.data.data.ostrzezenia || [];
        this.elementy = res.data.data.elementy || [];
      } catch (e) {
        if (mojNumer === this.numerZadania) this.blad(e, "Nie udało się odświeżyć podglądu.");
      } finally {
        if (mojNumer === this.numerZadania) this.ladujePodglad = false;
      }
    },

    // ─────────────────────────── edytor układu ───────────────────────────

    /** Ramka uchwytu w procentach kontenera; podczas ciągnięcia dokładamy przesunięcie. */
    ramkaUchwytu(el) {
      let dx = 0, dy = 0;
      if (this.przeciaganie && this.przeciaganie.id === el.id) {
        dx = this.przeciaganie.dx;
        dy = this.przeciaganie.dy;
      }
      return {
        left: (el.x + dx) * 100 + "%",
        top: (el.y + dy) * 100 + "%",
        width: Math.max(el.szerokosc, 0.02) * 100 + "%",
        height: Math.max(el.wysokosc, 0.015) * 100 + "%",
      };
    },

    zlapElement(el, zdarzenie) {
      this.wybranyId = el.id;
      const plotno = this.$refs.plotno;
      if (!plotno) return;
      const r = plotno.getBoundingClientRect();
      this.przeciaganie = {
        id: el.id,
        startX: zdarzenie.clientX, startY: zdarzenie.clientY,
        szerPlotna: r.width, wysPlotna: r.height,
        kotwicaX: el.kotwicaX, kotwicaY: el.kotwicaY,
        dx: 0, dy: 0,
      };
    },

    ciagnij(zdarzenie) {
      if (!this.przeciaganie) return;
      const p = this.przeciaganie;
      p.dx = (zdarzenie.clientX - p.startX) / p.szerPlotna;
      p.dy = (zdarzenie.clientY - p.startY) / p.wysPlotna;
    },

    /**
     * Puszczenie elementu. Przesunięcie zapisujemy dopiero TERAZ, a nie przy
     * każdym ruchu myszy — inaczej każdy piksel ciągnięcia wysyłałby żądanie
     * o nowy podgląd i edytor by się zaciął.
     */
    puscElement() {
      const p = this.przeciaganie;
      this.przeciaganie = null;
      if (!p || (Math.abs(p.dx) < 0.002 && Math.abs(p.dy) < 0.002)) return;
      this.nadpisz(p.id, {
        x: +(p.kotwicaX + p.dx).toFixed(4),
        y: +(p.kotwicaY + p.dy).toFixed(4),
      });
    },

    /** Zapis poprawki dla elementu. Vue 2 wymaga $set przy nowym kluczu. */
    nadpisz(id, pola) {
      const biezace = this.uklad.nadpisania[id] || {};
      this.$set(this.uklad.nadpisania, id, { ...biezace, ...pola });
    },

    przesun(dx, dy) {
      if (!this.wybrany) return;
      const n = this.nadpisanieWybranego;
      const x = n.x != null ? n.x : this.wybrany.kotwicaX;
      const y = n.y != null ? n.y : this.wybrany.kotwicaY;
      this.nadpisz(this.wybranyId, { x: +(x + dx).toFixed(4), y: +(y + dy).toFixed(4) });
    },

    /** Wyrównanie do lewego marginesu marki — najczęstsza poprawka. */
    wyrownajDoMarginesu() {
      if (!this.wybrany) return;
      this.nadpisz(this.wybranyId, { x: 0.0667 });
    },

    /** Kliknięcie albo przeciągnięcie po miniaturze wskazuje punkt ogniskowy. */
    zacznijKadr(zdarzenie) {
      this.kadrowanieWToku = true;
      this.ustawPunktKadru(zdarzenie);
    },
    ciagnijKadr(zdarzenie) {
      if (this.kadrowanieWToku) this.ustawPunktKadru(zdarzenie);
    },
    koniecKadru() {
      this.kadrowanieWToku = false;
    },
    ustawPunktKadru(zdarzenie) {
      const el = this.$refs.kadrownik;
      if (!el || !this.wybranyId) return;
      const r = el.getBoundingClientRect();
      const x = Math.min(1, Math.max(0, (zdarzenie.clientX - r.left) / r.width));
      const y = Math.min(1, Math.max(0, (zdarzenie.clientY - r.top) / r.height));
      this.nadpisz(this.wybranyId, { kadrX: +x.toFixed(3), kadrY: +y.toFixed(3) });
    },
    ustawPowiekszenie(wartosc) {
      if (this.wybranyId) this.nadpisz(this.wybranyId, { powiekszenie: +Number(wartosc).toFixed(2) });
    },
    wysrodkujKadr() {
      if (!this.wybranyId) return;
      const n = { ...this.nadpisanieWybranego };
      delete n.kadrX; delete n.kadrY; delete n.powiekszenie;
      this.$set(this.uklad.nadpisania, this.wybranyId, n);
    },

    ustawRozmiar(wartosc) {
      if (this.wybranyId) this.nadpisz(this.wybranyId, { rozmiar: +Number(wartosc).toFixed(4) });
    },
    ustawSzerokosc(wartosc) {
      if (this.wybranyId) this.nadpisz(this.wybranyId, { szerokosc: +Number(wartosc).toFixed(4) });
    },
    ustawWyrownanie(wartosc) {
      if (this.wybranyId) this.nadpisz(this.wybranyId, { wyrownanie: wartosc || undefined });
    },
    ustawKolor(nazwa) {
      if (!this.wybranyId) return;
      if (nazwa === null) {
        const n = { ...this.nadpisanieWybranego };
        delete n.kolor;
        this.$set(this.uklad.nadpisania, this.wybranyId, n);
      } else {
        this.nadpisz(this.wybranyId, { kolor: nazwa });
      }
    },

    ukryjElement() {
      if (this.wybranyId) {
        this.nadpisz(this.wybranyId, { ukryta: true });
        this.wybranyId = null;
      }
    },
    pokazElement(id) {
      const n = { ...(this.uklad.nadpisania[id] || {}) };
      delete n.ukryta;
      if (Object.keys(n).length) this.$set(this.uklad.nadpisania, id, n);
      else this.$delete(this.uklad.nadpisania, id);
    },
    przywrocElement() {
      if (this.wybranyId) this.$delete(this.uklad.nadpisania, this.wybranyId);
    },

    dodajElement(typ) {
      const id = "wlasny-" + Date.now().toString(36);
      const podstawa = { id, typ, etykieta: typ === "tekst" ? "Własny tekst" : (typ === "karta" ? "Własny kafelek" : "Własne zdjęcie") };
      if (typ === "tekst") {
        this.uklad.dodatkowe.push({
          ...podstawa, tekst: "Nowy tekst", x: 0.0667, y: 0.5,
          krój: "700", rozmiar: 0.03, kolor: "bialy", maksSzerokosc: 0.6, maksLinii: 2,
        });
      } else if (typ === "karta") {
        this.uklad.dodatkowe.push({
          ...podstawa, ramka: { x: 0.0667, y: 0.5, szerokosc: 0.4, wysokosc: 0.08 },
          tlo: "cta", cien: false,
        });
      } else {
        this.uklad.dodatkowe.push({
          ...podstawa, asset: this.assety.length ? this.assety[0].id : null,
          ramka: { x: 0.2, y: 0.35, szerokosc: 0.5, wysokosc: 0.25 },
        });
      }
      this.wybranyId = id;
    },

    usunDodany() {
      const i = this.uklad.dodatkowe.findIndex((d) => d.id === this.wybranyId);
      if (i >= 0) this.uklad.dodatkowe.splice(i, 1);
      this.$delete(this.uklad.nadpisania, this.wybranyId);
      this.wybranyId = null;
    },

    ustawTekstDodanego(wartosc) {
      if (this.elementDodany) this.$set(this.elementDodany, "tekst", wartosc);
    },
    ustawAssetDodanego(wartosc) {
      if (this.elementDodany) this.$set(this.elementDodany, "asset", wartosc);
    },

    async wyczyscUklad() {
      const potwierdzenie = await this.$swal.fire({
        icon: "warning", title: "Cofnąć wszystkie przesunięcia?",
        text: "Grafika wróci dokładnie do układu z szablonu. Teksty zostaną bez zmian.",
        showCancelButton: true, confirmButtonText: "Cofnij", cancelButtonText: "Zostaw",
      });
      if (!potwierdzenie.isConfirmed) return;
      this.uklad = { nadpisania: {}, dodatkowe: [] };
      this.wybranyId = null;
    },

    // ─────────────────────────── zapis i eksport ───────────────────────────

    async zapisz() {
      this.zapisuje = true;
      try {
        const dane = {
          tytul: this.tytulProjektu(),
          szablon: this.szablonKlucz,
          format: this.format,
          tresc: this.zbudujTresc(),
          teksty: this.teksty,
          uklad: this.uklad,
        };
        if (this.projektId) {
          await axios.put(this.api("/projekty/" + this.projektId), dane, this.getConfig());
        } else {
          const res = await axios.post(this.api("/projekty"), {
            ...dane, temat: this.temat, trybTworzenia: this.trybTworzenia,
          }, this.getConfig());
          this.projektId = res.data.data.id;
        }
        await Promise.all([this.wczytajProjekty(), this.odswiezProjekt()]);
        this.$swal.fire({ icon: "success", title: "Zapisano", timer: 1400, showConfirmButton: false });
      } catch (e) {
        this.blad(e, "Nie udało się zapisać projektu.");
      } finally {
        this.zapisuje = false;
      }
    },

    async eksportuj(formaty) {
      if (!this.projektId) return;
      this.eksportuje = true;
      try {
        await axios.post(this.api("/projekty/" + this.projektId + "/eksportuj"),
          { formaty, rozszerzenie: "png", skala: this.skalaEksportu }, this.getConfig());
        await this.odswiezProjekt();
        this.$swal.fire({
          icon: "success", title: "Gotowe",
          text: "Wyeksportowano " + formaty.length + (formaty.length === 1 ? " grafikę." : " grafiki."),
        });
      } catch (e) {
        this.blad(e, "Nie udało się wyeksportować grafiki.");
      } finally {
        this.eksportuje = false;
      }
    },

    async pobierzPlik(render) {
      if (!render.fileId) return;
      try {
        const res = await axios.post(
          process.env.VUE_APP_ROOT_API + "aws/download-file/" + render.fileId,
          {}, { ...this.getConfig(), responseType: "blob" },
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = (render.plik && render.plik.orginalName) || "grafika.png";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.blad(e, "Nie udało się pobrać pliku.");
      }
    },

    // ─────────────────────────── projekty ───────────────────────────

    /** Dociągnięcie historii i plików po zapisie albo eksporcie. */
    async odswiezProjekt() {
      if (!this.projektId) return;
      try {
        const res = await axios.get(this.api("/projekty/" + this.projektId), this.getConfig());
        this.wersje = res.data.data.wersje || [];
        this.rendery = res.data.data.rendery || [];
      } catch (e) {
        // odświeżenie historii nie jest krytyczne — projekt zapisał się tak czy tak
      }
    },

    async przywrocWersje(wersja) {
      const potwierdzenie = await this.$swal.fire({
        icon: "question",
        title: "Przywrócić wersję " + wersja.numer + "?",
        text: "Obecny stan zostanie zapisany w historii, więc będzie można do niego wrócić.",
        showCancelButton: true, confirmButtonText: "Przywróć", cancelButtonText: "Anuluj",
      });
      if (!potwierdzenie.isConfirmed) return;
      this.przywracam = wersja.numer;
      try {
        await axios.post(this.api("/projekty/" + this.projektId + "/przywroc-wersje"),
          { numer: wersja.numer }, this.getConfig());
        await this.otworz({ id: this.projektId });
        this.$swal.fire({ icon: "success", title: "Przywrócono", timer: 1400, showConfirmButton: false });
      } catch (e) {
        this.blad(e, "Nie udało się przywrócić wersji.");
      } finally {
        this.przywracam = null;
      }
    },

    async otworz(projekt) {
      try {
        const res = await axios.get(this.api("/projekty/" + projekt.id), this.getConfig());
        const p = res.data.data;
        this.projektId = p.id;
        this.szablonKlucz = p.szablon;
        this.format = p.format;
        this.temat = p.temat || "";
        this.tresc = { ...(p.tresc || {}) };
        this.korzysci = [...((p.tresc && p.tresc.korzysci) || []), "", "", ""].slice(0, 3);
        this.krokiPola = [...((p.tresc && p.tresc.kroki) || []), {}, {}, {}]
          .slice(0, 3)
          .map((k) => ({ tytul: k.tytul || "", opis: k.opis || "" }));
        this.wybraneZdjecie = (p.tresc && p.tresc.zdjecia && p.tresc.zdjecia[0]) || null;
        this.teksty = p.teksty || {};
        this.uklad = {
          nadpisania: (p.uklad && p.uklad.nadpisania) || {},
          dodatkowe: (p.uklad && p.uklad.dodatkowe) || [],
        };
        this.wybranyId = null;
        this.rendery = p.rendery || [];
        this.wersje = p.wersje || [];
        this.zakladka = 0;
        this.odswiezPodglad();
      } catch (e) {
        this.blad(e, "Nie udało się otworzyć projektu.");
      }
    },

    async zatwierdz(projekt) {
      try {
        await axios.patch(this.api("/projekty/" + projekt.id + "/zatwierdz"), {}, this.getConfig());
        await this.wczytajProjekty();
      } catch (e) {
        this.blad(e, "Nie udało się zatwierdzić projektu.");
      }
    },

    async usun(projekt) {
      const potwierdzenie = await this.$swal.fire({
        icon: "warning", title: "Usunąć projekt?",
        text: projekt.tytul, showCancelButton: true,
        confirmButtonText: "Usuń", cancelButtonText: "Anuluj",
      });
      if (!potwierdzenie.isConfirmed) return;
      try {
        await axios.delete(this.api("/projekty/" + projekt.id), this.getConfig());
        if (this.projektId === projekt.id) this.nowyProjekt();
        await this.wczytajProjekty();
      } catch (e) {
        this.blad(e, "Nie udało się usunąć projektu.");
      }
    },

    nowyProjekt() {
      this.projektId = null;
      this.rendery = [];
      this.wersje = [];
      this.teksty = {};
      this.temat = "";
      this.tresc = {};
      this.korzysci = ["", "", ""];
      this.krokiPola = [{ tytul: "", opis: "" }, { tytul: "", opis: "" }, { tytul: "", opis: "" }];
      this.wybraneZdjecie = null;
      this.svg = "";
      this.ostrzezenia = [];
      this.elementy = [];
      this.uklad = { nadpisania: {}, dodatkowe: [] };
      this.wybranyId = null;
    },

    // ─────────────────────────── biblioteka mediów ───────────────────────────

    /**
     * Grafika z AI trafia do biblioteki, a nie prosto do projektu — przechodzi
     * te sama droge co zdjecia prawdziwe, wiec mozna jej uzyc w kolejnych
     * postach zamiast placic drugi raz za to samo.
     */
    async wygenerujObraz() {
      this.generujeObraz = true;
      try {
        const res = await axios.post(this.api("/generuj-obraz"), this.obraz, this.getConfig());
        const { asset, kosztGrosze } = res.data.data;
        this.dialogObrazu = false;
        this.filtrKategorii = "WSZYSTKIE";
        await this.wczytajAssety();
        this.$swal.fire({
          icon: "success",
          title: "Gotowe",
          text: `„${asset.nazwa}" jest w bibliotece. Koszt: około ${kosztGrosze} gr.`,
        });
      } catch (e) {
        this.blad(e, "Nie udało się wygenerować grafiki.");
      } finally {
        this.generujeObraz = false;
      }
    },

    async wgrajAsset(zdarzenie) {
      const plik = zdarzenie.target.files && zdarzenie.target.files[0];
      if (!plik) return;
      this.wgrywa = true;
      try {
        const formularz = new FormData();
        formularz.append("file", plik);
        formularz.append("nazwa", plik.name);
        await axios.post(this.api("/assety"), formularz, this.getConfig());
        await this.wczytajAssety();
      } catch (e) {
        this.blad(e, "Nie udało się wgrać zdjęcia.");
      } finally {
        this.wgrywa = false;
        zdarzenie.target.value = "";
      }
    },

    /**
     * Miniatury lecą osobnymi żądaniami, bo pliki siedzą w S3 bez publicznego
     * adresu — `<img src>` sam ich nie pobierze, brakuje mu nagłówka z tokenem.
     * Pobieramy po kilka naraz, żeby siedemdziesiąt kafelków nie ruszyło
     * jednocześnie i nie zapchało przeglądarki.
     */
    async wczytajMiniatury() {
      const doPobrania = this.assety.filter((a) => !this.miniatury[a.id]);
      const NARAZ = 6;
      for (let i = 0; i < doPobrania.length; i += NARAZ) {
        const paczka = doPobrania.slice(i, i + NARAZ);
        await Promise.all(paczka.map(async (a) => {
          try {
            const res = await axios.get(this.api("/assety/" + a.id + "/miniatura"), {
              ...this.getConfig(), responseType: "blob",
            });
            this.$set(this.miniatury, a.id, window.URL.createObjectURL(res.data));
          } catch (e) {
            // brak jednej miniatury nie może zepsuć całej biblioteki
          }
        }));
      }
    },

    edytujAsset(asset) {
      this.edytowanyAsset = { ...asset };
      this.dialogAssetu = true;
    },

    async zapiszAsset() {
      this.zapisujeAsset = true;
      try {
        const a = this.edytowanyAsset;
        await axios.put(this.api("/assety/" + a.id), {
          nazwa: a.nazwa, kategoria: a.kategoria, prawa: a.prawa,
          aiWygenerowane: a.aiWygenerowane,
          widocznaPlatforma: a.widocznaPlatforma,
          widocznaTablica: a.widocznaTablica,
        }, this.getConfig());
        this.dialogAssetu = false;
        await this.wczytajAssety();
      } catch (e) {
        this.blad(e, "Nie udało się zapisać opisu.");
      } finally {
        this.zapisujeAsset = false;
      }
    },

    async usunAsset(asset) {
      const potwierdzenie = await this.$swal.fire({
        icon: "warning", title: "Usunąć materiał?", text: asset.nazwa,
        showCancelButton: true, confirmButtonText: "Usuń", cancelButtonText: "Anuluj",
      });
      if (!potwierdzenie.isConfirmed) return;
      try {
        await axios.delete(this.api("/assety/" + asset.id), this.getConfig());
        await this.wczytajAssety();
      } catch (e) {
        this.blad(e, "Nie udało się usunąć materiału.");
      }
    },

    // ─────────────────────────── drobne ───────────────────────────

    tytulProjektu() {
      return (this.temat || this.tresc.naglowek || "Post bez tytułu").slice(0, 140);
    },
    nazwaFormatuZKlucza(klucz) {
      const f = this.katalog.formaty.find((x) => x.klucz === klucz);
      return f ? f.nazwa : klucz;
    },
    powodUwagi(a) {
      const powody = [];
      if (a.widocznaPlatforma) powody.push("logo platformy");
      if (a.widocznaTablica) powody.push("tablica");
      return powody.join(", ");
    },
    kolorStatusu(status) {
      return {
        SZKIC: "grey", DO_WERYFIKACJI: "orange", ZATWIERDZONA: "success",
        ZAPLANOWANA: "info", OPUBLIKOWANA: "primary", ARCHIWALNA: "blue-grey",
      }[status] || "grey";
    },
    etykietaStatusu(status) {
      return {
        SZKIC: "Szkic", DO_WERYFIKACJI: "Do weryfikacji", ZATWIERDZONA: "Zatwierdzona",
        ZAPLANOWANA: "Zaplanowana", OPUBLIKOWANA: "Opublikowana", ARCHIWALNA: "Archiwalna",
      }[status] || status;
    },
    data(wartosc) {
      if (!wartosc) return "";
      return new Date(wartosc).toLocaleString("pl-PL", {
        day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit",
      });
    },
    kopiuj(tekst) {
      navigator.clipboard.writeText(tekst || "");
      this.$swal.fire({ icon: "success", title: "Skopiowano", timer: 1000, showConfirmButton: false });
    },
    blad(e, domyslny) {
      const tresc = (e && e.response && e.response.data && e.response.data.message) || domyslny;
      this.$swal.fire({ icon: "error", title: "Nie wyszło", text: Array.isArray(tresc) ? tresc.join(", ") : tresc });
    },
  },
};
</script>

<style scoped>
.marketing-page { padding: 8px 4px 32px; }

.sekcja-tytul {
  font-size: 14px; font-weight: 700; letter-spacing: 0.2px;
  color: #e6eaf2; margin-bottom: 10px;
}
.etykieta-grupy {
  font-size: 11px; font-weight: 700; letter-spacing: 0.8px;
  text-transform: uppercase; color: #94a0b8; margin: 8px 0 6px;
}
.wskazowka { font-size: 12px; color: #94a0b8; line-height: 1.45; }

.podglad-karta { position: sticky; top: 76px; }

.podglad-ramka {
  background: #0b111c; border: 1px solid #2a3a50; border-radius: 10px;
  padding: 14px; display: flex; justify-content: center; align-items: center;
  min-height: 320px;
}
/* SVG dostaje pełną szerokość kontenera i skaluje się sam — podgląd musi
   wyglądać tak samo na monitorze i na tablecie */
.podglad-svg { width: 100%; max-width: 460px; position: relative; user-select: none; }

/* Uchwyty leżą NA podglądzie i są przezroczyste do czasu najechania —
   inaczej ramki zasłaniałyby to, co użytkownik właśnie składa. */
.uchwyt {
  position: absolute;
  border: 1px dashed transparent;
  border-radius: 3px;
  cursor: grab;
  transition: border-color 0.12s, background 0.12s;
}
.uchwyt:hover { border-color: rgba(123, 198, 255, 0.7); background: rgba(49, 174, 245, 0.10); }
.uchwyt:active { cursor: grabbing; }
.uchwyt-wybrany {
  border-color: #31aef5;
  border-style: solid;
  background: rgba(49, 174, 245, 0.14);
  box-shadow: 0 0 0 1px rgba(3, 9, 20, 0.6);
}
.uchwyt-dodany { border-color: rgba(246, 200, 75, 0.75); }
.uchwyt-dodany.uchwyt-wybrany { border-color: #f6c84b; background: rgba(246, 200, 75, 0.16); }

.uchwyt-nazwa {
  position: absolute; top: -17px; left: 0;
  font-size: 9px; line-height: 14px; padding: 0 5px;
  background: #31aef5; color: #030914; border-radius: 3px;
  white-space: nowrap; opacity: 0; transition: opacity 0.12s; pointer-events: none;
}
.uchwyt:hover .uchwyt-nazwa, .uchwyt-wybrany .uchwyt-nazwa { opacity: 1; }
.uchwyt-dodany .uchwyt-nazwa { background: #f6c84b; }

.edytor {
  background: #131b28; border: 1px solid #2a3a50;
  border-radius: 8px; padding: 14px;
}

.kropka-koloru {
  width: 26px; height: 26px; border-radius: 50%;
  border: 2px solid #2a3a50; margin: 0 7px 7px 0; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
}
.kropka-wybrana { border-color: #ffffff; box-shadow: 0 0 0 2px #31aef5; }
.kropka-reset { background: #1a2433; color: #94a0b8; }
.podglad-svg >>> svg { width: 100%; height: auto; display: block; border-radius: 6px; }
.podglad-pusty { color: #6e7691; font-size: 13px; text-align: center; padding: 40px 12px; }

.panel-historii { background: transparent !important; }
.wersja {
  display: grid; grid-template-columns: 26px 1fr auto; gap: 10px;
  align-items: center; padding: 8px 0; border-bottom: 1px solid #2a3a50;
}
.wersja:last-child { border-bottom: 0; }
.wersja-numer {
  font-size: 12px; font-weight: 700; color: #6e7691;
  font-variant-numeric: tabular-nums; text-align: right;
}
.wersja-opis { font-size: 13px; color: #c4ccdb; min-width: 0; }

.probka { width: 128px; margin: 0 14px 16px 0; }
.probka-kolor { height: 56px; border-radius: 8px; border: 1px solid #2a3a50; }
.probka-nazwa { font-size: 12px; color: #e6eaf2; margin-top: 6px; }
.probka-hex { font-size: 11px; color: #94a0b8; font-family: monospace; }

.szablon-podglad {
  width: 100%; aspect-ratio: 4 / 5; border-radius: 6px; overflow: hidden;
  background: #0b111c; border: 1px solid #2a3a50;
  display: flex; align-items: center; justify-content: center;
}
.szablon-podglad img { width: 100%; height: 100%; object-fit: cover; display: block; }
.poz-mini-szablon { width: 40px; height: 50px; }

.kadrownik {
  position: relative; width: 100%; max-width: 280px; aspect-ratio: 4 / 3;
  border: 1px solid #2a3a50; border-radius: 6px; overflow: hidden;
  background: #0b111c; cursor: crosshair; margin-bottom: 8px; user-select: none;
}
.kadrownik img { width: 100%; height: 100%; object-fit: contain; display: block; pointer-events: none; }
.kadr-punkt {
  position: absolute; width: 18px; height: 18px; margin: -9px 0 0 -9px;
  border: 2px solid #ffffff; border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(3, 9, 20, .65), 0 0 10px rgba(49, 174, 245, .9);
  background: rgba(49, 174, 245, .35); pointer-events: none;
}

.krok-pola {
  display: grid; grid-template-columns: 30px 1fr; gap: 10px;
  align-items: start; margin-bottom: 14px;
}
.krok-numer {
  font-size: 15px; font-weight: 700; color: #5478ff;
  padding-top: 10px; font-variant-numeric: tabular-nums;
}

.poz-zdjecia { display: flex; align-items: center; gap: 12px; width: 100%; padding: 4px 0; }
.poz-mini {
  width: 56px; height: 42px; flex: none; border-radius: 4px; overflow: hidden;
  background: #0b111c; border: 1px solid #2a3a50;
}
.poz-mini img { width: 100%; height: 100%; object-fit: cover; display: block; }
.poz-mini-mala { width: 34px; height: 26px; }
.poz-opis { min-width: 0; }
.poz-nazwa {
  font-size: 13px; color: #e6eaf2;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
.poz-meta { font-size: 11px; color: #94a0b8; }
.poz-uwaga { color: #f5bb59; }
.poz-wybrana { display: flex; align-items: center; gap: 8px; min-width: 0; }

.podglad-zdjecia {
  border-radius: 6px; overflow: hidden; border: 1px solid #2a3a50; background: #0b111c;
}
.podglad-zdjecia img { width: 100%; max-height: 150px; object-fit: cover; display: block; }

.asset-podglad {
  width: 100%; aspect-ratio: 4 / 3; border-radius: 6px; overflow: hidden;
  background: #0b111c; border: 1px solid #2a3a50;
  display: flex; align-items: center; justify-content: center;
}
.asset-podglad img { width: 100%; height: 100%; object-fit: cover; display: block; }
.asset-podglad-pusty { color: #46536b; }

.asset-nazwa {
  font-size: 13px; color: #e6eaf2; font-weight: 600;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

.zasady { margin: 0; padding-left: 18px; color: #c4ccdb; font-size: 13px; line-height: 1.7; }
.h-100 { height: 100%; }
.transparent { background: transparent !important; }
</style>
